import React from 'react';

const DriverCalendar = ({ 
    currentDate, 
    yearlyAvailability, 
    saveMessage, 
    handleSaveChanges, 
    handleDateClick 
}) => {
    
    const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

    const year = currentDate.getFullYear();
    const monthCards = [];
      
    for(let m = 0; m < 12; m++) {
        const daysInMonth = getDaysInMonth(year, m);
        let firstDayIndex = new Date(year, m, 1).getDay();
        firstDayIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1; 
        
        const blanks = [];
        for (let i = 0; i < firstDayIndex; i++) blanks.push(<div key={`b-${m}-${i}`} className="calendar-day empty"></div>);
          
        const days = [];
        for (let d = 1; d <= daysInMonth; d++) {
            const date = new Date(year, m, d);
            const dayOfWeek = date.getDay();
            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            const data = yearlyAvailability[m]?.[d] || {};
              
            let bgColor = 'rgba(255,255,255,0.04)';
            let textColor = 'var(--text-muted)'; 
            let fontWeight = 'normal';
            let cursor = 'default';
              
            if (isWeekend) {
                textColor = 'var(--text-main)';
                fontWeight = 'bold';
                cursor = 'pointer';
                bgColor = 'rgba(255,255,255,0.06)';
                // Priority: Manager > User Status
                if (data.managerDecision === 'Working') { bgColor = '#15803d'; textColor = 'white'; } 
                else if (data.managerDecision === 'Not Legal') { bgColor = '#dc2626'; textColor = 'white'; } 
                else if (data.status === 'Holiday') { bgColor = '#facc15'; textColor = 'black'; }
                else if (data.status === 'Want to Work') { bgColor = '#3b82f6'; textColor = 'white'; } 
                else if (data.status === 'Available') { bgColor = '#22c55e'; textColor = 'white'; } 
                else if (data.status === 'Unavailable') { bgColor = '#64748b'; textColor = 'white'; }
            }

            days.push(
                <div 
                  key={`d-${m}-${d}`} 
                  className="calendar-day" 
                  onClick={isWeekend ? () => handleDateClick(m, d, data) : undefined}
                  style={{
                      backgroundColor: bgColor, 
                      color: textColor, 
                      fontWeight: fontWeight, 
                      cursor: cursor, 
                      fontSize:'10px', 
                      height:'25px', 
                      display:'flex', 
                      alignItems:'center', 
                      justifyContent:'center'
                  }}
                >
                    {d}
                </div>
            );
        }
          
        monthCards.push(
            <div key={m} className="card" style={{padding:'5px'}}>
                <h5 style={{textAlign:'center', margin:'0 0 5px 0', fontSize:'14px'}}>{monthNames[m]}</h5>
                <div style={{display:'grid', gridTemplateColumns:'repeat(7, 1fr)', gap:'2px', textAlign:'center', fontSize:'10px', fontWeight:'bold', marginBottom:'2px'}}>
                    <div>M</div><div>T</div><div>W</div><div>T</div><div>F</div><div>S</div><div>S</div>
                </div>
                <div style={{display:'grid', gridTemplateColumns:'repeat(7, 1fr)', gap:'2px'}}>
                    {blanks}
                    {days}
                </div>
            </div>
        );
    }

    return (
        <div className="animate-fade-in">
            <div className="card" style={{marginBottom:'15px', padding:'10px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <h4 style={{fontSize:'12px', textTransform:'uppercase', color:'var(--text-muted)', margin:0}}>Yearly Overview - {year}</h4>
                <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
                    {saveMessage && <span style={{fontSize:'12px', fontWeight:'bold', color:'var(--success)'}}>{saveMessage}</span>}
                    <button onClick={handleSaveChanges} style={{background:'var(--success)', color:'white', fontSize:'12px', padding:'8px 16px', boxShadow:'var(--shadow-md)'}}>💾 Save Changes</button>
                </div>
            </div>
              
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'10px'}}>
                {monthCards}
            </div>
        </div>
    );
};

export default DriverCalendar;